export const defaultInputDateFormat = 'yyyy-MM-dd';

export default {};
